export const historicalResults = {
    2020: {
      democratic: 306,
      republican: 232
    },
    2016: {
      democratic: 227,
      republican: 304
    },
    2012: {
      democratic: 332,
      republican: 206
    },
    2008: {
      democratic: 365,
      republican: 173
    }
  };